// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import Link from "@insite/mobius/Link"; // Starter Custom Code
import * as React from "react";
import { connect } from "react-redux";

/* Starter Custom Code - Start */
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import { linkPageTypeStyles } from "@store/Themes/common/mixins/link";
import { css } from "styled-components";
/* Starter Custom Code - End */

const enum fields {
    pageType = "pageType",
    overrideTitle = "overrideTitle",
    queryString = "queryString",
    testSelector = "testSelector",
    // Starter Custom Code
    linkAccessibleText = "linkAccessibleText",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.pageType]: string;
        [fields.overrideTitle]: string;
        [fields.queryString]: string;
        [fields.testSelector]: string;
        // Starter Custom Code
        [fields.linkAccessibleText]: string;
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    pageLink: getPageLinkByPageType(state, ownProps.fields.pageType),
});

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

/* Starter Custom Code - Start */
export interface PageTypeLinkStyles {
    link?: LinkPresentationProps;
}

export const pageTypeLinkStyles: PageTypeLinkStyles = {
    link: {
        css: css`
            ${linkPageTypeStyles()}
        `,
    },
};

const styles = pageTypeLinkStyles;
/* Starter Custom Code - End */

export const PageTypeLink: React.FC<Props> = ({
    pageLink,
    fields: { queryString, testSelector, overrideTitle, linkAccessibleText /* Starter Custom Code */ },
}) => {
    if (!pageLink) {
        return null;
    }

    const url = queryString ? `${pageLink.url}?${queryString}` : pageLink.url;

    const selector = testSelector;
    return (
        <Link href={url} data-test-selector={selector} {...styles.link /* Starter Custom Code */}>
            {overrideTitle || pageLink.title}
            {/* Starter Custom Code - Start */}
            {linkAccessibleText ? <VisuallyHidden>{linkAccessibleText}</VisuallyHidden> : null}
            {/* Starter Custom Code - End */}
        </Link>
    );
};

const pageTypeLink: WidgetModule = {
    component: connect(mapStateToProps)(PageTypeLink),
    definition: {
        group: "Basic",
        icon: "link",
        fieldDefinitions: [
            {
                fieldType: "General",
                name: fields.pageType,
                editorTemplate: "TextField",
                defaultValue: "",
                isRequired: true,
            },
            {
                fieldType: "Translatable",
                name: fields.overrideTitle,
                editorTemplate: "TextField",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.queryString,
                editorTemplate: "TextField",
                defaultValue: "",
            },
        ],
    },
};

export default pageTypeLink;
